<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      :mini-variant.sync="mini"
      :right="$store.getters.LANGUAGE == 'fa'"
      app
    >
      <v-list dense>
        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'Dashboard' }"
              exact
              v-on="on"
              v-if="showManagement"
            >
              <v-list-item-icon>
                <v-icon>fa fa-tachometer-alt</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("dashboard")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("dashboardToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'Employers' }"
              exact
              v-if="showEmployers"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>far fa-building</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("employers")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("employersToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'Users' }"
              exact
              v-if="showUsers"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-users</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("users")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("usersToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'SearchActivities' }"
              exact
              v-if="showSearchActivities"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-tasks</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("activities")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("activitiesToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'AdminUploads' }"
              exact
              v-if="showAdminUploads"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-photo-video</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("images")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("imagesToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'SearchImages' }"
              exact
              v-if="showSearchImages && showManagement"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-search</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("searchImages")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("searchImagesToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'AdminReports' }"
              v-if="showAdminReports"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-poll</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("reports")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("reportsToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'AdminTickets' }"
              v-if="showAdminSupport"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-ticket-alt</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("supportCenter")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("supportCenterToolTip") }}</span>
        </v-tooltip>

        <v-divider v-if="showServer"></v-divider>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'Models' }"
              exact
              v-if="showModels"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-database</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("models")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("modelsToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item :to="{ name: 'OS' }" exact v-if="showOS" v-on="on">
              <v-list-item-icon>
                <v-icon>fa-server</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("systemStatus")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("systemStatusToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item :to="{ name: 'Logs' }" exact v-if="showLogs" v-on="on">
              <v-list-item-icon>
                <v-icon>fa-bug</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("logs")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("logsToolTip") }}</span>
        </v-tooltip>

        <v-card flat v-if="showEmployerInfo">
          <v-img :src="employerLogo" contain></v-img>
          <v-card-title
            class="text-truncate"
            v-text="employerName"
          ></v-card-title>
          <v-card-subtitle
            class="text-truncate"
            v-text="contractorName"
          ></v-card-subtitle>
        </v-card>

        <v-divider v-if="showEmployerInfo"></v-divider>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'Dashboard' }"
              exact
              v-on="on"
              v-if="showDesktop"
            >
              <v-list-item-icon>
                <v-icon>fa fa-tachometer-alt</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("dashboard")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("dashboardToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'Colleagues' }"
              exact
              v-if="showColleagues"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-user-friends</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("colleagues")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("colleaguesToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'EmployerContractors' }"
              exact
              v-if="showEmployerContractors"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-user-friends</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("contractors")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("contractorsToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              href="/static/files/uav-standard.pdf"
              target="_blank"
              v-if="showUpload"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-helicopter</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("shootingGuide")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("shootingGuideToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'Upload' }"
              exact
              v-if="showUpload"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-upload</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("uploadImages")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("uploadImagesToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'Uploads' }"
              exact
              v-if="showUploads"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-photo-video</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("images")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("imagesToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="{ name: 'SearchImages' }"
              exact
              v-if="showSearchImages && showEmployerInfo"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>fa-search</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("searchImages")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("searchImagesToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item :to="{ name: 'Reports' }" v-if="showReports" v-on="on">
              <v-list-item-icon>
                <v-icon>fa-poll</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("reports")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("reportsToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item :to="{ name: 'Tickets' }" v-on="on">
              <v-list-item-icon>
                <v-icon>fa-headset</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("support")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("supportToolTip") }}</span>
        </v-tooltip>

        <v-divider></v-divider>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item :to="{ name: 'About' }" exact v-on="on">
              <v-list-item-icon>
                <v-icon>fa-info-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("about")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("aboutToolTip") }}</span>
        </v-tooltip>

        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item :to="{ name: 'ReleaseNotes' }" exact v-on="on">
              <v-list-item-icon>
                <v-icon>fa-history</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $vuetify.lang.translator("changes")
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("changesToolTip") }}</span>
        </v-tooltip>
      </v-list>

      <template v-slot:append>
        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on }">
            <v-list-item @click="mini = !mini" v-on="on">
              <v-list-item-icon>
                <v-icon>fa-exchange-alt</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <span>{{ $vuetify.lang.translator("resizeMenu") }}</span>
        </v-tooltip>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-right="$store.getters.LANGUAGE == 'fa'"
      :clipped-left="$store.getters.LANGUAGE == 'en'"
      color="blue"
      elevate-on-scroll
      app
    >
      <v-icon @click.stop="drawer = !drawer">fa-bars</v-icon>
      <v-app-bar-title style="width: 110px" class="mx-2">
        <v-tooltip
          :right="$store.getters.LANGUAGE == 'en'"
          :left="$store.getters.LANGUAGE == 'fa'"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-img
              :alt="$vuetify.lang.translator('logoAlt')"
              src="@/assets/logo.png"
              class="hidden-sm-and-down"
              max-width="100px"
              contain
              v-bind="attrs"
              v-on="on"
            ></v-img>
          </template>
          {{ $vuetify.lang.translator("appTitle") }}
        </v-tooltip>
      </v-app-bar-title>
      {{ $vuetify.lang.translator("appName") }}
      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon
              v-on:click="$vuetify.theme.dark = !$vuetify.theme.dark"
              v-if="!$vuetify.theme.dark"
            >
              fa-moon
            </v-icon>
            <v-icon
              v-on:click="$vuetify.theme.dark = !$vuetify.theme.dark"
              v-if="$vuetify.theme.dark"
            >
              fa-sun
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.translator("changeTheme") }}</span>
      </v-tooltip>

      <v-menu transition="fab-transition" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>fa-user</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-subheader>{{ userName }}</v-subheader>

          <v-list-item :to="{ name: 'Profile' }" exact>
            <v-list-item-icon>
              <v-icon>fa-id-badge</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $vuetify.lang.translator("profile")
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'Activities' }" exact>
            <v-list-item-icon>
              <v-icon>fa-history</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $vuetify.lang.translator("activities")
            }}</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item :to="{ name: 'Logout' }" exact>
            <v-list-item-icon>
              <v-icon>fa-sign-out-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $vuetify.lang.translator("signOut")
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "MyNavigation",
  data: () => ({
    selected: null,
    drawer: null,
    mini: false,
    userName: null,
    showManagement: false,
    showEmployers: false,
    showUsers: false,
    showSearchActivities: false,
    showAdminUploads: false,
    showAdminReports: false,
    showEmployerInfo: false,
    showDesktop: false,
    showColleagues: false,
    showUploads: false,
    showUpload: false,
    showReports: false,
    showEmployerContractors: false,
    showOS: false,
    showModels: false,
    showServer: false,
    showLogs: false,
    showSearchImages: false,
    showAdminSupport: false,
    employerLogo: "",
    employerName: "",
    contractorName: ""
  }),
  created() {
    this.userName = this.$store.getters.NAME;
    if (this.$store.getters.EMPLOYERLOGO) {
      this.employerLogo =
        process.env.VUE_APP_URL + this.$store.getters.EMPLOYERLOGO;
    }
    this.employerName = this.$store.getters.EMPLOYERNAME;
    this.contractorName = this.$store.getters.CONTRACTORNAME;
    let userType = parseInt(this.$store.getters.USERTYPE);
    if (userType >= 1 && userType <= 2) {
      this.showManagement = true;
      this.showEmployers = true;
      this.showUsers = true;
      this.showAdminUploads = true;
      this.showAdminReports = true;
      this.showSearchImages = true;
    }
    if (userType === 1) {
      this.showSearchActivities = true;
      this.showOS = true;
      this.showModels = true;
      this.showServer = true;
      this.showLogs = true;
      this.showAdminSupport = true;
    }
    if (userType >= 3 && userType <= 7) {
      this.showEmployerInfo = true;
      this.showDesktop = true;
      this.showColleagues = true;
    }
    if (userType === 3 || userType === 4) {
      this.showEmployerContractors = true;
    }
    if (userType === 3 || userType === 4 || userType === 5 || userType === 7) {
      this.showUpload = true;
      this.showUploads = true;
      this.showSearchImages = true;
    }
    if (userType === 3 || userType === 4 || userType === 6 || userType === 7) {
      this.showReports = true;
    }
  },
  methods: {}
};
</script>
